<template>
    <i :class='iconClasses'/>
</template>

<script>
export default {
    name: "BooleanIcon",
    props: {
        boolean: {
            required: true,
            type: Boolean,
        },
    },
    computed: {
        iconClasses() {
            return this.boolean ? "fa fa-check text-success" : "fa fa-times text-danger";
        },
    },
};
</script>

<style scoped>

</style>